import React from 'react'
import { v4 as uuid4 } from 'uuid'

export default class SVGWrapper extends React.Component {
    constructor(props) {
        super(props)

        this.uuid = uuid4()
    }

    render() {
        const { title, fill } = this.props

        return (
            <>
                {React.Children.map(this.props.children, (child, i) => {
                    return React.cloneElement(child, {
                        title,
                        titleId: `${this.uuid}_${i}`,
                        'aria-labelledby': `${this.uuid}_${i}`,
                        fill
                    })
                })}
            </>
        )
    }
}
